// extracted by css-extract-rspack-plugin
export default {"cls1":"MultiPaperNewsStory-cls1_EAQ","cls2":"MultiPaperNewsStory-cls2_wQ3 MultiPaperNewsStory-cls1_EAQ"};